export const countries: Record<string,string> = {
    AF: "Afghanistan",
    AL: "Albanie",
    DZ: "Algérie",
    AS: "Samoa américaines",
    AD: "Andorre",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctique",
    AG: "Antigua-et-Barbuda",
    AR: "Argentine",
    AM: "Arménie",
    AW: "Aruba",
    AU: "Australie",
    AT: "Autriche",
    AZ: "Azerbaïdjan",
    BS: "Bahamas",
    BH: "Bahreïn",
    BD: "Bangladesh",
    BB: "Barbade",
    BY: "Bélarus",
    BE: "Belgique",
    BZ: "Belize",
    BJ: "Bénin",
    BM: "Bermudes",
    BT: "Bhoutan",
    BO: "Bolivie",
    BA: "Bosnie-Herzégovine",
    BW: "Botswana",
    BV: "Île Bouvet",
    BR: "Brésil",
    IO: "Territoire britannique de l'océan Indien",
    BN: "Brunei Darussalam",
    BG: "Bulgarie",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodge",
    CM: "Cameroun",
    CA: "Canada",
    CV: "Cap-Vert",
    KY: "Îles Caïmans",
    CF: "République centrafricaine",
    TD: "Tchad",
    CL: "Chili",
    CN: "Chine",
    CX: "Île Christmas",
    CC: "Îles Cocos (Keeling)",
    CO: "Colombie",
    KM: "Comores",
    CG: "Congo",
    CD: "Congo, République démocratique du",
    CK: "Îles Cook",
    CR: "Costa Rica",
    HR: "Croatie",
    CU: "Cuba",
    CY: "Chypre",
    CZ: "République tchèque",
    DK: "Danemark",
    DJ: "Djibouti",
    DM: "Dominique",
    DO: "République dominicaine",
    EC: "Équateur",
    EG: "Égypte",
    SV: "El Salvador",
    GQ: "Guinée équatoriale",
    ER: "Érythrée",
    EE: "Estonie",
    ET: "Éthiopie",
    FK: "Îles Falkland (Malvinas)",
    FO: "Îles Féroé",
    FJ: "Fidji",
    FI: "Finlande",
    FR: "France",
    GF: "Guinée française",
    PF: "Polynésie française",
    TF: "Terres australes françaises",
    GA: "Gabon",
    GM: "Gambie",
    GE: "Géorgie",
    DE: "Allemagne",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Grèce",
    GL: "Groenland",
    GD: "Grenade",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernesey",
    GN: "Guinée",
    GW: "Guinée-Bissau",
    GY: "Guyana",
    HT: "Haïti",
    HM: "Îles Heard et McDonald",
    VA: "Saint-Siège (État de la Cité du Vatican)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hongrie",
    IS: "Islande",
    IN: "Inde",
    ID: "Indonésie",
    IR: "République islamique d'Iran",
    IQ: "Iraq",
    IE: "Irlande",
    IM: "Île de Man",
    IL: "Israël",
    IT: "Italie",
    JM: "Jamaïque",
    JP: "Japon",
    JE: "Jersey",
    JO: "Jordanie",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "République populaire démocratique de Corée",
    KR: "République de Corée",
    KW: "Koweït",
    KG: "Kirghizistan",
    LA: "République démocratique populaire du Laos",
    LV: "Lettonie",
    LB: "Liban",
    LS: "Lesotho",
    LR: "Libéria",
    LY: "Jamahiriya arabe libyenne",
    LI: "Liechtenstein",
    LT: "Lituanie",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macédoine, Ex-République yougoslave",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaisie",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malte",
    MH: "Îles Marshall",
    MQ: "Martinique",
    MR: "Mauritanie",
    MU: "Maurice",
    YT: "Mayotte",
    MX: "Mexique",
    FM: "Micronésie, États fédérés de",
    MD: "Moldova, République de",
    MC: "Monaco",
    MN: "Mongolie",
    ME: "Monténégro",
    MS: "Montserrat",
    MA: "Maroc",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibie",
    NR: "Nauru",
    NP: "Népal",
    NL: "Pays-Bas",
    NC: "Nouvelle-Calédonie",
    NZ: "Nouvelle-Zélande",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigéria",
    NU: "Niue",
    NF: "Île Norfolk",
    MP: "Îles Mariannes du Nord",
    NO: "Norvège",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palaos",
    PS: "Territoires palestiniens",
    PA: "Panama",
    PG: "Papouasie-Nouvelle-Guinée",
    PY: "Paraguay",
    PE: "Pérou",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Pologne",
    PT: "Portugal",
    PR: "Porto Rico",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Roumanie",
    RU: "Fédération de Russie",
    RW: "Rwanda",
    BL: "Saint-Barthélemy",
    SH: "Sainte-Hélène, Ascension et Tristan da Cunha",
    KN: "Saint-Kitts-et-Nevis",
    LC: "Sainte-Lucie",
    MF: "Saint-Martin (partie française)",
    PM: "Saint-Pierre-et-Miquelon",
    VC: "Saint-Vincent-et-les Grenadines",
    WS: "Samoa",
    SM: "Saint-Marin",
    ST: "Sao Tomé-et-Principe",
    SA: "Arabie saoudite",
    SN: "Sénégal",
    RS: "Serbie",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapour",
    SX: "Saint-Martin (partie néerlandaise)",
    SK: "Slovaquie",
    SI: "Slovénie",
    SB: "Îles Salomon",
    SO: "Somalie",
    ZA: "Afrique du Sud",
    GS: "Géorgie du Sud et les îles Sandwich du Sud",
    SS: "Soudan du Sud",
    ES: "Espagne",
    LK: "Sri Lanka",
    SD: "Soudan",
    SR: "Suriname",
    SJ: "Svalbard et Île Jan",
    TR: "Turquie",
    VN: "Viet Nam",
};